import './Modal.css';

import React, { useContext, useEffect, useState } from 'react';
import { IonModal } from '@ionic/react';
import { Link } from 'react-router-dom';
import { CloseButton } from './CloseButton';
import { useLogger } from '../../services/LogService';
import { AppContext } from '../../state/AppContextProvider';

type Props = {
  content?: any;
  contentRender?: (currentPath: string) => any;
  ModalUrl: string;
  urlMatcher?: (modalUrl: string, currentPath: string) => boolean;
  backUrl?: string;
  addClass?: string;
  hideCloseBtn?: boolean;
};

export const Modal: React.FC<Props> = (props) => {
  const [showModal, setShowModal] = useState(false);

  const logger = useLogger('Modal');

  const { state } = useContext(AppContext);

  useEffect(() => {
    const isMatchingPath = (path: string) =>
      (props.urlMatcher && props.urlMatcher(props.ModalUrl, path)) ||
      path === props.ModalUrl;
    logger.info(
      `useEffect() for ${props.ModalUrl}, path: ${state.currentPath}, previousPath: ${state.previousPath}, backUrl: ${props.backUrl}`
    );
    if (isMatchingPath(state.currentPath)) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.currentPath, props.ModalUrl]);

  const openModale = (e) => {
    setShowModal(true);
  };

  const closeModale = (e) => {
    logger.debug(
      `closeModale() backUrl: ${props.backUrl}, currentPath: ${state.currentPath}, previousPath: ${state.previousPath}`
    );
    setShowModal(false);
  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        cssClass={`md:bg-none lg:transform-none ${props.addClass}`}
      >
        <div
          className={`modal-cross z-50 absolute top-6 left-3 md:top-14 md:left-14 ${
            props.hideCloseBtn === true ? 'hidden' : ''
          }`}
        >
          <CloseButton
            to={props.backUrl || state.previousPath}
            onClick={closeModale}
          />
        </div>

        {(props.contentRender && props.contentRender(state.currentPath)) ||
          props.content}
      </IonModal>
      <Link to={props.ModalUrl}>
        <div className="h-full" onClick={openModale}>
          {props.children}
        </div>
      </Link>
    </>
  );
};
